import api from "../api";

export default class CardsApi {
  getCard() {
    return api.get("/users/profile/get_card");
  }
  getCardV2(id: string) {
    return api.post("/users/profile/get_card_v2", { aggregate_token: id });
  }
  getStandard(institution_name: string, year: number) {
    return api.post("/users/profile/card/images/standard", {
      institution_name: institution_name,
      year: year,
    });
  }
}
